module.exports = __webpack_public_path__ + "static/img/03bg.70c71f7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/03bg.png
// module id = iuVZ
// module chunks = 0